import React from "react";

export default function ML_Learning() {
  return (
    <div>
      <h1>ML_Learning</h1>
      <p>This is the ML_Learning component.</p>
    </div>
  );
}
